import '@/styles/globals.css'
import '@/styles/webflow/normalize.css'
import '@/styles/webflow/webflow.css'
import '@/styles/webflow/az-milano.webflow.css'
import '@/styles/animations.css'
import '@/styles/cart.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { useEffect } from 'react'
import { useRouter } from 'next/router'

import { CartProvider } from '@/lib/cart'

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    const router = useRouter()

    // Re-arm the pre-paint hide on client-side navigation so the next page's
    // reveal elements never flash before their animations are wired.
    useEffect(() => {
        const arm = () => document.documentElement.classList.add('is-loading')
        const disarm = () =>
            window.setTimeout(() => document.documentElement.classList.remove('is-loading'), 1200)

        router.events.on('routeChangeStart', arm)
        router.events.on('routeChangeComplete', disarm)
        router.events.on('routeChangeError', disarm)

        return () => {
            router.events.off('routeChangeStart', arm)
            router.events.off('routeChangeComplete', disarm)
            router.events.off('routeChangeError', disarm)
        }
    }, [router])

    return (
        <CartProvider>
            <Component {...pageProps} />
        </CartProvider>
    )
}

export default App
